<style lang="less" scoped>
  .number-row {
    display: flex;
    width: 100%;
    align-items: center;
    font-size: 32px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.38;
    letter-spacing: normal;
    color: #ffffff;
  }
  .name {
    padding-right: 24px;
  }
  .input {
    flex: 1;
  }
  .unit {
    padding-left: 16px;
  }
</style>

<template lang="pug">
  .number-row
    .name {{name}}
    .input
      el-input-number.std-number-input(
        v-model='number'
        controls-position='right'
        @change='handleChange'
        :min='min'
        :max='max')
    .unit {{unit}}
</template>

<script>
export default {
  data() {
    return {
      number: 0,
    };
  },
  props: {
    name: {
      type: String,
      default: null,
    },
    unit: {
      type: String,
      default: null,
    },
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 10,
    },
    default: {
      type: Number,
    },
  },
  methods: {
    handleChange() {
      this.$emit('change', this.number);
    },
  },
  mounted() {
    if (this.default) {
      this.number = this.default;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/number.vue